function getAppNameFromPath(basePath, path) {
    return path
        .substring(basePath.length)
        .toLowerCase()
        .split('/')
        .find(segment => segment.trim() != '');
}

export { getAppNameFromPath }
